import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";

interface WhatsAppButtonProps {
  phoneNumber: string; 
  message?: string; 
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ phoneNumber, message }) => {
  const location = useLocation();

  const hiddenRoutes = ["/invoices", "/expenses", "/user-management", "/inventories", "/customers", "/quotes"];
  const shouldHideButton = hiddenRoutes.some(route => location.pathname.startsWith(route));

  if (shouldHideButton) return null;

  const openWhatsApp = () => {
    const encodedMessage = encodeURIComponent(message || "Hello! I need some help.");
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(url, "_blank");
  };

  return (
    <div
      className="fixed bottom-5 right-5 bg-green-500 text-white p-3 rounded-full shadow-lg cursor-pointer hover:bg-green-600 transition-all"
      onClick={openWhatsApp}
    >
      <FaWhatsapp size={30} />
    </div>
  );
};

export default WhatsAppButton;
